// extracted by mini-css-extract-plugin
module.exports = {"count":"count__Yrrw9","subject":"subject__JumUS","text":"text__2sM_C","divider":"divider__Dnq_B","container":"container__1fziG","bold":"bold__1AJAv"};